// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.displayInlineFlex {
  margin: 0 2px 5px 0;
  display: inline-flex;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-filter-widget/np-filter-bar.vue","webpack://./np-filter-bar.vue"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,oBAAA;ACAR","sourcesContent":["\n    .displayInlineFlex {\n        margin: 0 2px 5px 0;\n        display: inline-flex;\n    }\n",".displayInlineFlex {\n  margin: 0 2px 5px 0;\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
